import api from '@/api'
import { firebaseApp, firebaseFunctions } from '@/firebase'

const store = {
  state: {
    dataMerchantConfig: [],
    pagingMerchantConfig: {
      page: 1,
      size: 20,
      total: 0
    },
    sortingMerchantConfig: {
      byField: '',
      isDesc: false
    },
    filteringMerchantConfig: {
      outletCode: '',
      edcMapping: '',
      printingType: '',
      printingAddress: '',
      autoPrintStages: '',
      isAutoPrintReceipt: '',
      status: ''
    }
  },

  mutations: {
    SET_MERCHANTITEM: (state, payload) => {
      state.dataMerchantConfig = payload
    },
    SET_PAGING_PAGE_MERCHANTITEM: (state, payload) => {
      state.pagingMerchantConfig.page = payload
    },
    SET_PAGING_TOTAL_MERCHANTITEM: (state, payload) => {
      state.pagingMerchantConfig.total = payload
    },
    SET_SORTING_MERCHANTITEM: (state, payload) => {
      state.sortingMerchantConfig = payload
    },
    SET_FILTERING_MERCHANTITEM: (state, payload) => {
      state.filteringMerchantConfig = payload
    }
  },

  getters: {
    SortingMerchantConfig: state => state.sortingMerchantConfig,
    FilteringMerchantConfig: state => state.filteringMerchantConfig,
    PagingMerchantConfig: state => state.pagingMerchantConfig,
    GetAllMerchantConfig: state => state.dataMerchantConfig,
    GetOneMerchantConfig: state => id =>
      state.dataMerchantConfig.find(
        dataMerchantConfig => dataMerchantConfig.id === id
      )
  },

  actions: {
    async UpdateSortingMerchantConfig({ commit, dispatch }, payload) {
      commit('SET_SORTING_MERCHANTITEM', {
        byField: payload.byField,
        isDesc: payload.isDesc
      })
      dispatch('GetAllMerchantConfig')
    },

    async UpdateFilteringMerchantConfig(
      { commit, dispatch, state },
      isResetField
    ) {
      if (isResetField) {
        const emptyFilter = {
          cond: null,
          code: null,
          description: null,
          sequence: null,
          outletCode: ''
        }
        commit('SET_FILTERING_MERCHANTITEM', emptyFilter)
      }
      commit('SET_PAGING_PAGE_MERCHANTITEM', 1)
      dispatch('GetAllMerchantConfig')
    },

    async GetAllMerchantConfig({ commit, state }) {
      try {
        commit('SET_IS_FETCHING_DATA', true)
        const result = await api.GetAllMerchantConfig(
          state.pagingMerchantConfig,
          state.sortingMerchantConfig,
          state.filteringMerchantConfig
        )
        commit('SET_IS_FETCHING_DATA', false)
        commit('SET_MERCHANTITEM', result.data.data)
        commit('SET_PAGING_TOTAL_MERCHANTITEM', result.headers['data-length'])
        return result.data
      } catch (e) {
        commit('SET_IS_FETCHING_DATA', false)
        throw e
      }
    },

    async CreateMerchantConfig({ dispatch }, payload) {
      try {
        const { data } = await api.CreateMerchantConfig(payload)
        dispatch('GetAllMerchantConfig')
        return data
      } catch (e) {
        return e.response
      }
    },

    async UpdateMerchantConfig({ dispatch }, payload) {
      try {
        const { data } = await api.UpdateMerchantConfig(payload.id, payload)
        dispatch('GetAllMerchantConfig')
        return data
      } catch (e) {
        return e.response
      }
    },

    async DeleteMerchantConfig({ dispatch }, id) {
      try {
        const { data } = await api.DeleteMerchantConfig(id)
        dispatch('GetAllMerchantConfig')
        return data
      } catch (e) {
        throw e
      }
    }
  }
}

export default store
